import { useCallback, useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Yousign } from 'helpers/yousign'
import dayjs from 'dayjs'
import classNames from 'classnames'
import api from 'helpers/api'
import style from './Signature.module.scss'

const RCProSignature = () => {
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const signatureLink = state?.signatureLink
  const hasHandledSignature = useRef(false)
  const project = pathname.split('/')[1]

  const onSignatureSuccess = useCallback(
    async data => {
      try {
        await api.put({
          url: `/adhesions/${state.adhesionId}/signature/subscription/client`,
          data: {
            adhesionId: state.saveID,
            signature: 1,
            signatureHorodate: dayjs(data.timeStamp).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
          },
          headers: { Authorization: `Bearer ${state.token}` },
        })
      } catch (error) {
        console.log('Update adhesion status error')
      }
    },
    [state],
  )


  useEffect(() => {
    if (signatureLink) {
      const yousign = new Yousign({
        signatureLink: signatureLink,
        iframeContainerId: 'signature-iframe',
        isSandbox: true, //To set if you use the sandbox environment
      })

      yousign.onSuccess(() => {
        if (hasHandledSignature.current) return
        hasHandledSignature.current = true
        onSignatureSuccess({ timeStamp: new Date() })
        localStorage.removeItem(project === 'rc-pro' ? 'RCPro' : project)
        window.history.replaceState({}, '')
      })

      yousign.onError(() => {
        console.log('Error on signing the document')
      })
    }
  }, [navigate, state, onSignatureSuccess, signatureLink, project])


  return (
    <div
      className={classNames(style['signature-iframe'], !signatureLink && style.inactive)}
      id="signature-iframe"
    ></div>
  )
}

export default RCProSignature